import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import ImageValidationDialog from "components/Dialog/ImageValidationDialog";
import SessionExpiryDialog from "components/Dialog/SessionExpiryDialog";
import { ToastContainer } from "components/Snackbar";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import routes from "routes";
import { persistor, store } from "store/configureStore";
import theme from "styles/muiCustomTheme";
import "../src/styles/global.css";

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ThemeProvider theme={theme}>
          {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
          <CssBaseline />
          <RouterProvider router={routes} />
          <ToastContainer />
          <SessionExpiryDialog />
          <ImageValidationDialog />
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
